var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _g49, _g50, _g51, _g52, _g53, _g54, _g55, _g56, _g57, _g58, _g59, _g60, _g61, _g62, _g63, _g64, _g65, _g66, _g67, _g68, _g69, _g70, _g71, _g72, _g73, _g74, _g75, _g76, _g77, _g78, _g79, _g80, _g81, _g82, _g83, _g84, _g85, _g86, _g87, _g88, _g89, _g90, _g91, _g92, _g93, _g94, _g95, _g96;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconProgressbarCalculate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "300px",
    height: "300px",
    viewBox: "0 0 300 300",
    enableBackground: "new 0 0 300 300",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_97"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_96"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_95"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_94"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_93"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_92"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_91"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_90"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_89"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_88"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_87"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_86"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_85"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_84"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_83"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_82"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_81"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_80"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_79"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_78"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_77"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_76"
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_75"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_74"
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_73"
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_72"
  })), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_71"
  })), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_70"
  })), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_69"
  })), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_68"
  })), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_67"
  })), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_66"
  })), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_65"
  })), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_64"
  })), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_63"
  })), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_62"
  })), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_61"
  })), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_60"
  })), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_59"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#137F7B",
    d: "M161.18,227.445v1.812c0,1.326-1.07,2.397-2.398,2.397h-17.564c-1.325,0-2.398-1.071-2.398-2.397v-17.566 c0-0.984,0.595-1.828,1.444-2.196c-3.319-3.608-6.434-7.4-9.349-11.327c-0.301,0.133-0.63,0.211-0.977,0.211h-17.566 c-1.325,0-2.396-1.074-2.396-2.397v-17.566c0-1.322,1.071-2.396,2.396-2.396h4.626c-1.971-3.694-3.813-7.415-5.522-11.128h-4.377 c-1.322,0-2.396-1.072-2.396-2.396v-13.789c-3.131-8.27-5.681-16.213-7.739-23.403v113.618c0,3.082,2.51,5.59,5.59,5.59h94.898 c1.789,0,3.386-0.852,4.407-2.17C186.294,240.446,172.821,235.087,161.18,227.445z M132.332,229.257 c0,1.326-1.072,2.397-2.395,2.397h-17.566c-1.325,0-2.396-1.071-2.396-2.397v-17.566c0-1.322,1.071-2.395,2.396-2.395h17.566 c1.322,0,2.395,1.072,2.395,2.395V229.257z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M150,19.666C78.133,19.666,19.665,78.133,19.665,150S78.133,280.334,150,280.334 S280.335,221.867,280.335,150S221.867,19.666,150,19.666z M207.828,238.921c0,5.725-4.655,10.381-10.378,10.381h-94.898 c-5.723,0-10.38-4.657-10.38-10.381V97.844c0-5.723,4.657-10.381,10.38-10.381h9.619V54.147c0-1.322,1.077-2.395,2.398-2.395 h70.862c1.324,0,2.397,1.073,2.397,2.395v33.316h9.621c5.723,0,10.378,4.658,10.378,10.381V238.921z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M197.45,92.255h-9.621v23.625h5.071c1.322,0,2.395,1.075,2.395,2.398c0,1.323-1.072,2.395-2.395,2.395 h-7.469h-70.862h-7.468c-1.326,0-2.396-1.072-2.396-2.395c0-1.324,1.07-2.398,2.396-2.398h5.069V92.255h-9.619 c-3.08,0-5.59,2.509-5.59,5.589v27.459c2.059,7.19,4.608,15.133,7.739,23.403v-13.154c0-1.323,1.074-2.396,2.396-2.396H192.9 c1.325,0,2.398,1.073,2.398,2.396v26.942c0,1.324-1.073,2.396-2.398,2.396h-17.862c-1.324,0-2.394-1.072-2.394-2.396 c0-1.322,1.069-2.397,2.394-2.397h15.468v-22.15h-81.015v22.15h53.538c1.323,0,2.396,1.075,2.396,2.397 c0,1.324-1.073,2.396-2.396,2.396h-51.555c1.71,3.713,3.552,7.434,5.522,11.128h12.94c1.322,0,2.395,1.074,2.395,2.396v17.566 c0,0.976-0.585,1.813-1.418,2.187c2.915,3.927,6.029,7.719,9.349,11.327c0.294-0.126,0.614-0.198,0.954-0.198h17.564 c1.328,0,2.398,1.072,2.398,2.395v15.754c11.642,7.643,25.114,13.001,40.678,14.896c0.737-0.946,1.179-2.131,1.179-3.42V97.844 C203.036,94.764,200.529,92.255,197.45,92.255z M161.18,195.981c0,1.324-1.07,2.397-2.398,2.397h-17.564 c-1.325,0-2.398-1.074-2.398-2.397v-17.566c0-1.322,1.073-2.396,2.398-2.396h17.564c1.328,0,2.398,1.074,2.398,2.396V195.981z  M190.027,229.257c0,1.326-1.075,2.397-2.396,2.397h-17.568c-1.322,0-2.396-1.071-2.396-2.397v-17.566 c0-1.322,1.074-2.395,2.396-2.395h17.568c1.321,0,2.396,1.072,2.396,2.395V229.257z M190.027,195.981 c0,1.324-1.075,2.397-2.396,2.397h-17.568c-1.322,0-2.396-1.074-2.396-2.397v-17.566c0-1.322,1.074-2.396,2.396-2.396h17.568 c1.321,0,2.396,1.074,2.396,2.396V195.981z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M183.039,92.255V89.86v-2.396V56.544h-66.074v30.919v2.396v2.395v23.625h66.074V92.255z M161.469,78.233 l-1.808,6.448h-16.182v2.258h16.182l-0.147,0.524l-0.673,2.396l-0.671,2.395l-0.319,1.132H144.75 c2.284,4.928,7.132,8.061,10.016,8.061c3.866,0,8.705,0,8.705,0l1.449,7.255c0,0-3.271,0-11.952,0 c-7.037,0-13.982-7.309-16.362-15.316h-4.715v-1.132V89.86v-2.396v-0.524h3.85v-2.258h-3.85v-6.448h4.971 c2.592-7.686,9.306-14.51,16.106-14.51c8.681,0,11.952,0,11.952,0l-1.449,7.256c0,0-4.839,0-8.705,0 c-2.723,0-7.197,2.792-9.611,7.254H161.469z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "114.768,180.81 114.768,193.587 127.541,193.587 127.541,193.453 127.541,180.81 119.636,180.81 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.608,
    y: 180.81,
    fill: "#FFFFFF",
    width: 12.778,
    height: 12.778
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.458,
    y: 180.81,
    fill: "#FFFFFF",
    width: 12.777,
    height: 12.778
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.768,
    y: 214.088,
    fill: "#FFFFFF",
    width: 12.773,
    height: 12.774
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "143.608,214.088 143.608,226.862 156.387,226.862 156.387,224.099 156.387,214.088 144.708,214.088  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.458,
    y: 214.088,
    fill: "#FFFFFF",
    width: 12.777,
    height: 12.774
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M150,10.334C72.988,10.334,10.335,72.988,10.335,150c0,77.012,62.653,139.666,139.665,139.666 S289.665,227.012,289.665,150C289.665,72.988,227.012,10.334,150,10.334z M150,280.334c-71.867,0-130.335-58.468-130.335-130.334 S78.133,19.666,150,19.666S280.335,78.133,280.335,150S221.867,280.334,150,280.334z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M197.45,87.463h-9.621V54.147c0-1.322-1.073-2.395-2.397-2.395h-70.862c-1.321,0-2.398,1.073-2.398,2.395 v33.316h-9.619c-5.723,0-10.38,4.658-10.38,10.381v141.077c0,5.725,4.657,10.381,10.38,10.381h94.898 c5.723,0,10.378-4.657,10.378-10.381V97.844C207.828,92.121,203.173,87.463,197.45,87.463z M116.965,92.255V89.86v-2.396V56.544 h66.074v30.919v2.396v2.395v23.625h-66.074V92.255z M203.036,238.921c0,1.289-0.441,2.474-1.179,3.42 c-1.021,1.318-2.618,2.17-4.407,2.17h-94.898c-3.08,0-5.59-2.508-5.59-5.59V125.303V97.844c0-3.081,2.51-5.589,5.59-5.589h9.619 v23.625h-5.069c-1.326,0-2.396,1.075-2.396,2.398c0,1.323,1.07,2.395,2.396,2.395h7.468h70.862h7.469 c1.322,0,2.395-1.072,2.395-2.395c0-1.324-1.072-2.398-2.395-2.398h-5.071V92.255h9.621c3.079,0,5.586,2.509,5.586,5.589V238.921 z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M192.9,133.156h-85.803c-1.322,0-2.396,1.073-2.396,2.396v13.154v13.789c0,1.324,1.074,2.396,2.396,2.396 h4.377h51.555c1.323,0,2.396-1.072,2.396-2.396c0-1.322-1.073-2.397-2.396-2.397h-53.538v-22.15h81.015v22.15h-15.468 c-1.324,0-2.394,1.075-2.394,2.397c0,1.324,1.069,2.396,2.394,2.396H192.9c1.325,0,2.398-1.072,2.398-2.396v-26.942 C195.299,134.229,194.226,133.156,192.9,133.156z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M129.938,176.018h-12.94h-4.626c-1.325,0-2.396,1.074-2.396,2.396v17.566 c0,1.324,1.071,2.397,2.396,2.397h17.566c0.347,0,0.676-0.078,0.977-0.211c0.833-0.374,1.418-1.21,1.418-2.187v-17.566 C132.332,177.092,131.26,176.018,129.938,176.018z M127.541,193.453v0.135h-12.773V180.81h4.868h7.905V193.453z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M158.781,176.018h-17.564c-1.325,0-2.398,1.074-2.398,2.396v17.566c0,1.324,1.073,2.397,2.398,2.397 h17.564c1.328,0,2.398-1.074,2.398-2.397v-17.566C161.18,177.092,160.109,176.018,158.781,176.018z M156.387,193.587h-12.778 V180.81h12.778V193.587z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M187.631,176.018h-17.568c-1.322,0-2.396,1.074-2.396,2.396v17.566c0,1.324,1.074,2.397,2.396,2.397 h17.568c1.321,0,2.396-1.074,2.396-2.397v-17.566C190.027,177.092,188.952,176.018,187.631,176.018z M185.235,193.587h-12.777 V180.81h12.777V193.587z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M154.766,70.979c3.866,0,8.705,0,8.705,0l1.449-7.256c0,0-3.271,0-11.952,0 c-6.801,0-13.515,6.824-16.106,14.51h-4.971v6.448h3.85v2.258h-3.85v0.524v2.396v2.395v1.132h4.715 c2.38,8.007,9.325,15.316,16.362,15.316c8.681,0,11.952,0,11.952,0l-1.449-7.255c0,0-4.839,0-8.705,0 c-2.884,0-7.731-3.132-10.016-8.061h13.101l0.319-1.132l0.671-2.395l0.673-2.396l0.147-0.524h-16.182v-2.258h16.182l1.808-6.448 h-16.314C147.568,73.771,152.043,70.979,154.766,70.979z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M129.938,209.296h-17.566c-1.325,0-2.396,1.072-2.396,2.395v17.566c0,1.326,1.071,2.397,2.396,2.397 h17.566c1.322,0,2.395-1.071,2.395-2.397v-17.566C132.332,210.369,131.26,209.296,129.938,209.296z M127.541,226.862h-12.773 v-12.774h12.773V226.862z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M158.781,209.296h-17.564c-0.34,0-0.66,0.072-0.954,0.198c-0.85,0.368-1.444,1.212-1.444,2.196v17.566 c0,1.326,1.073,2.397,2.398,2.397h17.564c1.328,0,2.398-1.071,2.398-2.397v-1.812v-15.754 C161.18,210.369,160.109,209.296,158.781,209.296z M156.387,224.099v2.763h-12.778v-12.774h1.1h11.679V224.099z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M187.631,209.296h-17.568c-1.322,0-2.396,1.072-2.396,2.395v17.566c0,1.326,1.074,2.397,2.396,2.397 h17.568c1.321,0,2.396-1.071,2.396-2.397v-17.566C190.027,210.369,188.952,209.296,187.631,209.296z M185.235,226.862h-12.777 v-12.774h12.777V226.862z"
  }))))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_58"
  })), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_57"
  })), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_56"
  })), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_55"
  })), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_54"
  })), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_53"
  })), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_52"
  })), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_51"
  })), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_50"
  })), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_49"
  })), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_48"
  })), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_47"
  })), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_46"
  })), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_45"
  })), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_44"
  })), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_43"
  })), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_42"
  })), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_41"
  })), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_40"
  })), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_39"
  })), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_38"
  })), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_37"
  })), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_36"
  })), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_35"
  })), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_34"
  })), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_33"
  })), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_32"
  })), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_31"
  })), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_30"
  })), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_29"
  })), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_28"
  })), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_27"
  })), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_26"
  })), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_25"
  })), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_24"
  })), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_23"
  })), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_22"
  })), _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_21"
  })), _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_20"
  })), _g80 || (_g80 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_19"
  })), _g81 || (_g81 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_18"
  })), _g82 || (_g82 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_17"
  })), _g83 || (_g83 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_16"
  })), _g84 || (_g84 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_15"
  })), _g85 || (_g85 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_14"
  })), _g86 || (_g86 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_13"
  })), _g87 || (_g87 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_12"
  })), _g88 || (_g88 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_11"
  })), _g89 || (_g89 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_10"
  })), _g90 || (_g90 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_9"
  })), _g91 || (_g91 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_8"
  })), _g92 || (_g92 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_7"
  })), _g93 || (_g93 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_6"
  })), _g94 || (_g94 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  })), _g95 || (_g95 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  })), _g96 || (_g96 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProgressbarCalculate);
export default __webpack_public_path__ + "static/media/icon_progressbar_calculate.9ac37cd1fe847763fc80f6450b883080.svg";
export { ForwardRef as ReactComponent };